import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { FONTS, SCREEN_PADDING, TYPOGRAPHY } from '@/styles';
import {
  Platform,
  StyleProp,
  Text,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native';

export enum FilterType {
  BUTTON = 'BUTTON',
  TAB = 'TAB',
}

interface Props {
  count?: number;
  filterType?: FilterType;
  isSelected?: boolean;
  onPress: () => void;
  style?: StyleProp<ViewStyle>;
  text: string;
}

export const FilterButton: React.FC<Props> = ({
  count,
  filterType = FilterType.BUTTON,
  isSelected,
  onPress,
  style,
  text,
}) => {
  const [styles] = useStyles();
  const isButtonType = filterType === FilterType.BUTTON;
  return (
    <TouchableOpacity onPress={onPress} style={styles.container}>
      <View
        style={[
          isButtonType ? styles.base : styles.baseTab,
          style,
          isSelected
            ? isButtonType
              ? styles.baseSelected
              : styles.baseTabSelected
            : null,
        ]}
      >
        <Text
          numberOfLines={1}
          style={[
            TYPOGRAPHY.small,
            FONTS.primarySemiBold,
            Platform.OS === 'web' ? styles.text : null,
            isSelected && isButtonType ? styles.textSelected : null,
          ]}
        >
          {text}
        </Text>
        {typeof count === 'number' && count > 0 ? (
          <View style={styles.count}>
            <Text
              style={[
                TYPOGRAPHY.xsmall,
                FONTS.primarySemiBold,
                styles.countText,
              ]}
            >
              {count}
            </Text>
          </View>
        ) : null}
      </View>
    </TouchableOpacity>
  );
};

const useStyles = createStyles((theme) => ({
  base: {
    alignItems: 'center',
    backgroundColor: theme.colors.white,
    borderColor: theme.colors.stroke,
    borderRadius: 4,
    borderWidth: 1,
    flexDirection: 'row',
    marginRight: 8,
    maxWidth: 200,
    paddingHorizontal: 8,
    paddingVertical: 4,
  },
  baseSelected: {
    backgroundColor: theme.colors.accent,
    borderColor: theme.colors.accent,
  },
  baseTab: {
    alignItems: 'center',
    backgroundColor: theme.colors.white,
    borderBottomColor: theme.colors.white,
    borderBottomWidth: 4,
    borderTopColor: theme.colors.white,
    borderTopWidth: 4,
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    maxWidth: 200,
    paddingHorizontal: SCREEN_PADDING,
  },
  baseTabSelected: {
    borderBottomColor: theme.colors.accent,
  },
  container: {
    justifyContent: 'center',
  },
  count: {
    alignItems: 'center',
    backgroundColor: theme.sk.color.bg.tertiary.default,
    borderRadius: 16,
    height: 16,
    justifyContent: 'center',
    marginLeft: 4,
    width: 16,
  },
  countText: {
    color: theme.sk.color.text.secondary,
  },
  text: {
    flex: 1,
  },
  textSelected: {
    color: theme.colors.accentText,
  },
}));
